// extracted by mini-css-extract-plugin
export default {"favourite":"style-module--favourite--45710","favouriteDescription":"style-module--favouriteDescription--27068"};